import { createStyles, makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) =>
    createStyles({
        buttonGroup: {
            display: "flex",
            flexDirection: "row",
            gap: "0.5em",
            // justifyContent: "space-between",
            flexWrap: "wrap",
        },
        button: {
            backgroundColor: "transparent",
            boxShadow: "none",
            borderColor: theme.palette.common.black,
            fontWeight: "bold",
            "&:hover": {
                backgroundColor: theme.palette.secondary.main,
                boxShadow: "none",
                borderColor: theme.palette.secondary.main,
                color: theme.palette.common.white,
            },
        },
    }),
);
